import { useTheme } from "@mui/material/styles";
import * as React from 'react';
import LogoutIcon from "../../../assets/images/icons/menu/logoutIcon";
import User3Icon from "../../../assets/images/icons/toolbar/user3Icon";
import useUserAction from "../../../hooks/user/useUserAction";
import useUserData from "../../../hooks/user/useUserData";
import { EXHIBITION } from "../../../locales/components/namespaces";
import { useTranslation } from "react-i18next";
import {
	Avatar,
	Box,
	ButtonBase,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Menu,
	Stack,
	Typography
} from "@mui/material";

export default function AccountMenu() {
	const { t } = useTranslation(EXHIBITION)
	const theme = useTheme()
	const { loginName } = useUserData()
	const [anchorEl, setAnchorEl] = React.useState(null)
	const open = Boolean(anchorEl)
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}
	
	const { userLogout } = useUserAction()
	return (
		<React.Fragment>
			<Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
				<ButtonBase
					aria-label="open profile"
					//ref={anchorRef}
					aria-controls={open ? 'profile-grow' : undefined}
					aria-haspopup="true"
					onClick={handleClick}
				>
					<Stack direction="row" spacing={2} alignItems="center" sx={{ p: 0.5 }}>
						<Avatar
							sx={{
								backgroundColor: open ? theme.palette.highlight.dark : theme.palette.highlight.main,
								borderRadius: '8px',
								width: '40px',
								height: '40px',
								'&:hover': {
									background: theme.palette.highlight.dark
								}
							}}
							color={'text.primary'}
						>
							<User3Icon/>
						</Avatar>
					</Stack>
				</ButtonBase>
			</Box>
			<Menu
				anchorEl={anchorEl}
				id="account-menu"
				open={open}
				onClose={handleClose}
				slotProps={{
					paper: {
						elevation: 0,
						sx: {
							overflow: 'visible',
							filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
							mt: 1.5,
							pb: '24px',
							pt: '16px',
							pr: '24px',
							pl: '24px',
							minWidth: '198px',
							maxHeight: '160px',
							borderRadius: '12px',
							'&:before': {
								content: '""',
								display: 'block',
								position: 'absolute',
								top: 0,
								right: 20,
								width: 12,
								height: 12,
								bgcolor: 'background.paper',
								transform: 'translateY(-50%) rotate(45deg)',
								zIndex: 0,
								borderRadius: '2px',
							},
						},
					}
				}}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			>
				<ListItem sx={{ p: 0 }}>
					<ListItemText sx={{ m: 0 }}>
						<Typography color={'text.main'} variant="body">
							{`${t('User')}:`}
						</Typography>
					</ListItemText>
				</ListItem>
				<ListItem sx={{ p: 0, mb: '20px' }}>
					<ListItemText sx={{ m: 0 }}>
						<Typography color={'text.main'} variant="body" fontWeight={700}>
							{`${loginName}`}
						</Typography>
					</ListItemText>
				</ListItem>
				<ListItem sx={{ p: 0 }}>
					<ListItemButton
						sx={{
							background: theme.palette.error.main,
							borderRadius: '8px',
							maxHeight: '40px',
							color: '#fff',
							'&:hover': {
								background: theme.palette.error.dark
							}
						}}
						onClick={userLogout}
					>
						<ListItemIcon>
							<LogoutIcon fontSize="small"/>
						</ListItemIcon>
						{/*<ListItemText*/}
						{/*	primary={t('Logout')}*/}
						{/*/>*/}
						{t('Logout')}
					</ListItemButton>
				</ListItem>
			</Menu>
		</React.Fragment>
	)
}
